import * as preact from "preact";
import { $$ } from "../../Core/References";
import { DataPanel, IDataPanelProps } from "../../Common/DataPanel/DataPanel";
import { CitationManager } from "../CitationManager/CitationManager";


export interface IContentEditorProps extends IDataPanelProps<IContentData>
{
    Descriptor?: string;
    OnPaste?: Function;
}

interface IContentData
{
    Details?: string,
    Citations?: EventLibrary.Model.Citation[];
}

export class ContentEditor extends DataPanel<IContentData, IContentEditorProps>
{
    private _btnNew: HTMLAnchorElement;
    private _citationManager: CitationManager;
    private _currentRange: Range;
    private _txtContent: HTMLElement;

    public constructor(props: IContentEditorProps)
    {
        super(props);
    }

    public override setData(data: IContentData)
    {
        $$.addCssClass(this._btnNew, "disabled");
        this._txtContent.innerHTML = data.Details || "";
        this._citationManager.setData(data.Citations);
        super.setData(data);
    }

    public override getData(data?: IContentData): IContentData
    {
        data = super.getData(data);
        let html = this._txtContent.innerHTML;

        //Remove extra line breaks
        html = html.replace(/(<div>(\s*|(<br>))<\/div >){2,}/gi, "<div><br/></div>");

        data.Details = html;
        data.Citations = this._citationManager.getData();

        return data;
    }

    public override focus()
    {
        $$.focus(this._txtContent);
    }

	private _onContentClick(evtArgs)
	{
		this._checkCitationLink();
	}

	private _onContentFocus()
    {
        $$.removeCssClass(this._btnNew, "disabled");
	}

	private _onContentBlur(evtArgs)
	{
		this._currentRange = window.getSelection().getRangeAt(0);
	}

	private _onKeyPress(evtArgs)
	{
		if(evtArgs.key === "[")
		{
			setTimeout(this._checkCitationLink.bind(this));
		}
	}

	private _checkCitationLink()
	{
		var range = window.getSelection().getRangeAt(0);

        // alter start and end of cloned ranged, so it selects incorrectTxt.length characters
		var startOffset = range.startOffset;
		if(startOffset > 1)
		{
			// clone the range, so we can alter the start and end
			var clone = range.cloneRange();                
            
			clone.setStart(range.startContainer, startOffset - 2); 
			clone.setEnd(range.startContainer, startOffset);
			if(clone.toString().indexOf("[[") >= 0)
			{
				this._citationManager.openEditor();
			}
		}
	}

	private _onAddCitationClick()
	{
		this._citationManager.openEditor();
	}

	private _onCitationSelected(number)
    {
		this._currentRange.deleteContents();
		var textNode = document.createTextNode("["+number+"]"); 
		this._currentRange.insertNode(textNode);
		$$.focus(this._txtContent);
		this._currentRange.collapse(false);
		var selection = window.getSelection();
		selection.removeAllRanges();
		selection.addRange(this._currentRange);
    }

    private _onCitationDeleted(number)
    {
        let html = this._txtContent.innerHTML;
        let regex = new RegExp("\\[" + number + "\\]", "gi");
        html = html.replace(regex, "");
        html = html.replace(/\[([0-9]+)\]/gi, (match: string, p1: string) =>
        {
            let index = parseInt(p1, 10);
            if (index > number)
            {
                index--;
                
            }
            return "[" + index.toString() + "]";
        })
        this._txtContent.innerHTML = html;
    }

    private _onContentPaste(e): void
    {
        e.preventDefault();

        let clipboardData = (e.originalEvent || e).clipboardData;
        var text = clipboardData.getData("text/plain") as string;
        let html = clipboardData.getData("text/html") as string;

        let citations = this._citationManager.getData();

        //remove wikipedia citations
        text = text.replace(/\[([0-9]+|[a-z]{1})\](:[0-9]+)?/gi, (match: string, citationValue: string) =>
        {
            let citationNumber = parseInt(citationValue);
            if (citationNumber > 0 && citationNumber <= citations?.length)
            {
                return match;
            }
            return "";
        });

        //another wikipedia citation
        text = text.replace(/\[citation needed\]/gi, "");

        //remove beginning and trailing spaces
        text = text.trim();

        //Normalize line breaks
        if (text.indexOf("\r\n") > -1)
        {
            text = text.replace(/(\r\n)+/gi, "</div><div><br/></div><div>");
        }
        else
        {
            text = text.replace(/(\n)+/gi, "</div><div><br/></div><div>");
        }

        text = "<div>" + text + "</div>";

        // insert text manually
        document.execCommand("insertHTML", false, text.trim());

        if (this.props.OnPaste)
        {
            this.props.OnPaste(html);
        }
    }
    
    public render()
    {
        return (<div ref={(container) => this._registerContainer(container)} style={{ width: "547px", position: "relative" }}>
            {this.props.Descriptor ? (<span className="inputLabel">{this.props.Descriptor}</span>) : null}
            <div>
                <div className="contentEditor" ref={(content) => this._txtContent = content} contentEditable={true} style={{ height: "200px", width: "100%" }} onClick={this._onContentClick.bind(this)} onKeyPress={this._onKeyPress.bind(this)} onFocus={this._onContentFocus.bind(this)} onBlur={this._onContentBlur.bind(this)} onPaste={this._onContentPaste.bind(this)}>
            </div>
                </div>
            <div style={{ marginBottom: "8px" }}><a href="javascript:void(0)" ref={(ref) => this._btnNew = ref} onClick={this._onAddCitationClick.bind(this)}>Add citation</a></div>
         <CitationManager ref={(ref) => this._citationManager = ref} onCitationSelected={this._onCitationSelected.bind(this)} onCitationDeleted={this._onCitationDeleted.bind(this)} /> 
        </div>);
    }
}